module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/toolbar/deleteLine-32716b.svg";